import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../../utils/api";

const API = process.env.REACT_APP_API_URL;

export default function StepKitchen({ data, errors = {}, onChange, onBack, onNext }) {
  const token = localStorage.getItem("token");
  const [autoMsg, setAutoMsg] = useState("");

  // Auto-detect authority
  useEffect(() => {
    let ignore = false;
    const detect = async () => {
      if (data.authority_name) {
        setAutoMsg("Auto-filled from your postcode. Change if needed.");
        return;
      }
      try {
        setAutoMsg("Detecting your local authority…");
        const r = await axios.get(`${API}/auth/applications/authority`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const detected = r?.data?.authority_name;
        if (!ignore && detected) {
          onChange({ authority_name: detected });
          setAutoMsg("Auto-filled from your postcode. Change if needed.");
        }
      } catch {
        setAutoMsg("Couldn’t auto-detect. Please fill manually.");
      }
    };
    detect();
    return () => { ignore = true; };
  }, [data.authority_name, onChange, token]);

  const toggleArrayValue = (key, value) => {
    const arr = Array.isArray(data[key]) ? [...data[key]] : [];
    if (arr.includes(value)) {
      onChange({ [key]: arr.filter((v) => v !== value) });
    } else {
      onChange({ [key]: [...arr, value] });
    }
  };

  return (
    <div className="add-form">
      {/* Preparation address */}
      <label>
        <span className="lbl">Preparation address</span>
        <input
          value={data.prep_address || ""}
          onChange={(e) => onChange({ prep_address: e.target.value })}
          className={errors.prep_address ? "invalid" : ""}
        />
      </label>

      {/* Trading address */}
      <label>
        <span className="lbl">Trading address (optional)</span>
        <input
          value={data.trading_address || ""}
          onChange={(e) => onChange({ trading_address: e.target.value })}
        />
      </label>

      {/* Start date */}
      <label>
        <span className="lbl">Planned start date</span>
        <input
          type="date"
          value={data.start_date || ""}
          onChange={(e) => onChange({ start_date: e.target.value })}
          className={errors.start_date ? "invalid" : ""}
        />
      </label>

      {/* Opening hours */}
      <label>
        <span className="lbl">Opening hours</span>
        <input
          value={data.opening_hours || ""}
          onChange={(e) => onChange({ opening_hours: e.target.value })}
          className={errors.opening_hours ? "invalid" : ""}
        />
      </label>

      {/* Water supply */}
      <label>
        <span className="lbl">Water supply</span>
        <select
          value={data.water_supply || ""}
          onChange={(e) => onChange({ water_supply: e.target.value })}
          className={errors.water_supply ? "invalid" : ""}
        >
          <option value="">Select</option>
          <option value="public">Public mains</option>
          <option value="private">Private supply</option>
        </select>
      </label>

      {/* Processing activities */}
      <fieldset>
        <legend>Processing activities (tick all that apply)</legend>
        {["Cooking", "Storing chilled food", "Freezing", "Vacuum-packing"].map((act) => (
          <label key={act} className="checkbox">
            <input
              type="checkbox"
              checked={Array.isArray(data.processing_activities) && data.processing_activities.includes(act)}
              onChange={() => toggleArrayValue("processing_activities", act)}
            />
            <span>{act}</span>
          </label>
        ))}
      </fieldset>

      {/* Sales scale */}
      <fieldset>
        <legend>Scale of sales</legend>
        {["Local customers", "Online sales"].map((opt) => (
          <label key={opt} className="checkbox">
            <input
              type="checkbox"
              checked={Array.isArray(data.sales_scale) && data.sales_scale.includes(opt)}
              onChange={() => toggleArrayValue("sales_scale", opt)}
            />
            <span>{opt}</span>
          </label>
        ))}
      </fieldset>

      {/* Authority */}
      <label>
        <span className="lbl">Local authority</span>
        <div className="row" style={{ gap: 8 }}>
          <input
            value={data.authority_name || ""}
            onChange={(e) => onChange({ authority_name: e.target.value })}
            placeholder="e.g., Slough Borough Council"
          />
          <button type="button" className="btn ghost small" onClick={() => window.location.reload()}>
            Auto-fill
          </button>
        </div>
        {autoMsg && <small className="hint">{autoMsg}</small>}
      </label>

      <div className="actions">
        <button className="btn ghost" onClick={onBack}>Back</button>
        <button className="btn" onClick={onNext}>Next</button>
      </div>
    </div>
  );
}

